import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions, ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {SoundConfig} from "./config/sound/SoundConfig";
import {SoundManager} from "./config/sound/SoundManager";
import {RoadRage} from "./RoadRage";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TranslationTexts} from "./config/translate/TranslationTexts";


export class RoadRagePanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Road rage",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any): boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue =  response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice = RoadRage.model.getBuyFeaturePrice;
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }


    private getWin(response: any, bet: number, prevData: any): number {
        return response.totalSpinWinnings;
    }

    private isFreeSpinTriggered(response: any): boolean {
        return response.mode == "NORMAL" && response.nextMode == "FREESPIN_SETUP";
    }

    private getFeatureName(response: any): string {

        if (response.mode != "NORMAL" || response.nextMode != "NORMAL") {
            const count = ArrayHelper.countWithCondition(response.scatterReels, (v:boolean) => v)
            switch (count) {
                case 3:
                    return TranslationTexts.FREESPINS;
                case 4:
                    return TranslationTexts.FREESPINS_SUPER;
                default:
                    return TranslationTexts.FREESPINS_UBER;
            }
        }

        return response.nextMode;
    }

    private isRoundComplete(response: any): boolean {
        //FREESPIN_SETUP
        //FREESPIN
        //NORMAL
        //RESPIN
        return (["FREESPIN", "NORMAL", "FREESPIN_SETUP"].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: any): boolean {
        return ((response.nextMode === "NORMAL") && (response.mode === "FREESPIN"));
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            SoundManager.soundPlayer.playTrack({name:SoundConfig.AS_WIN});
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.soundPlayer.playTrack({name:SoundConfig.AS_WIN_BIG});
        }
    }


}